class FileService {

    $lv

    get $http() {
        return this.$lv.Vue.prototype.$http
    }

    get $dialog() {
        return this.$lv.Vue.prototype.$dialog
    }

    _input;
    get input() {
        if (!this._input) {
            this._input = document.createElement('input')
            this._input.setAttribute('type', 'file')
            this._input.style.display = 'none'
            document.body.appendChild(this._input)
        }
        return this._input
    }

    type = {
        image: 'image/gif, image/jpeg, image/png, image/jpg',
        excel: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }

    get typeKeys() {
        return Object.keys(this.type)
    }

    constructor($lv) {
        this.$lv = $lv
    }

    /**
     * 获取文件
     * @author  韦胜健
     * @date    2019/8/15 15:24
     * @param   multiple            文件是否多选
     * @param   accept              文件类型，input的accept属性
     * @param   validFunc           文件校验函数
     * @param   maxSize             文件最大的大小
     */
    getFile({multiple = false, accept = null, validFunc = null, maxSize = null} = {}) {
        !!multiple ? this.input.setAttribute('multiple', 'multiple') : this.input.removeAttribute('multiple')
        if (!!accept) {
            if (this.typeKeys.indexOf(accept) > -1) {
                this.input.setAttribute('accept', this.type[accept])
            } else {
                this.input.setAttribute('accept', accept)
            }
        } else {
            this.input.removeAttribute('accept')
        }

        return new Promise((rs) => {
            if (!!this.input._change) {
                this.input.value = null
                this.input.removeEventListener('change', this.input._change)
                this.input._change = null
            }
            this.input._change = async e => {
                const files = []
                for (let i = 0; i < e.target.files.length; i++) {
                    const file = e.target.files[i];
                    file.calcSize = (file.size / (1024 * 1024)).toFixed(2)
                    if (!!validFunc && !validFunc(file)) return
                    if (!!maxSize && (file.calcSize) > maxSize) {
                        this.$dialog.show(LinkVue.$t('LinkService.overMaxSize', {name: file.name, nowSize: file.calcSize, maxSize}))
                        return
                    }
                    files.push(file)
                }
                rs(multiple ? files : files[0])
            }
            this.input.addEventListener('change', this.input._change);
            this.input.click()
        })
    }

    /**
     * 读取图片文件得到base64字符串
     * @author  韦胜健
     * @date    2019/8/15 15:25
     */
    readAsDataURL(file) {
        return new Promise((rs, rj) => {
            let fr = new FileReader();
            fr.onloadend = e => {
                rs(e.target.result);
                fr = null;
            };
            fr.readAsDataURL(file);
        })
    }


    /**
     * 上传文件
     * @author  韦胜健
     * @date    2019/7/21 19:14
     * @param   action                  //上传url地址
     * @param   data                    //上传数据
     * @param   headers                 //上传额外请求头信息
     * @param   withCredentials         //是否发送 cookie 凭证信息
     * @param   file                    //上传的文件
     * @param   filename                //后端接收文件的name
     * @param   onProgress              //上传进度监听函数
     * @param   onSuccess               //上传成功监听函数
     * @param   onError                 //上传失败监听函数
     */
    upload({action, data, headers, withCredentials, file, filename = 'uploadAttachment', withToken = true, onProgress, onSuccess, onError} = {}) {

        const formData = new FormData()
        if (!!data) Object.keys(data).forEach(key => formData.append(key, data[key]))
        if (this.$lv.$utils.typeOf(file) === 'array') {
            file.forEach(f => formData.append(filename, f))
        } else {
            formData.append(filename, file);
        }

        const $http = this.$lv.Vue.prototype.$http

        /*如果使用 系统中的 axios和axios1，会自动带 token，如果使用 $http.axios（原生的axios），咋不回自动加token*/
        const axios = withToken ? $http.variable.axios : $http.axios
        let defaultHeaders = {'Content-Type': 'multipart/form-data'}

        axios({
            url: action || `action/${LinkVue.prefixUrl}/attachment/insertWithFiles`,
            method: 'post',
            headers: Object.assign({}, defaultHeaders, headers),
            data: formData,
            withCredentials,
            onUploadProgress(e) {
                if (e.total > 0) e.percent = (e.loaded / e.total * 100).toFixed(2) - 0
                !!onProgress && onProgress(e)
            },
        }).then((response) => {
            !!onSuccess && onSuccess(response.data)
        }).catch((error) => {
            !!onError && onError(error)
        })

    }

    /**
     * 获取图片，自动上传
     * @createdby：WangYue
     * @date：2018/12/18
     * @param headId        图片头id
     * @param moduleType    图片模块字段值
     * @param multiple      是否需要多张图片
     * @param url           图片上传地址
     * @param beforeUpload  上传前触发动作
     * @param afterUpload   上传后触发事件
     */
    getImageAutoUpload({headId, moduleType, multiple, url, beforeUpload, afterUpload} = {}) {

        url = url || `action/${LinkVue.prefixUrl}/attachment/insertWithFiles`

        return new Promise(async (rs, rj) => {
            const images = await this.getFile({multiple, accept: 'image'})
            !!beforeUpload && beforeUpload({images})
            this.upload({
                action: url,
                data: {headId, moduleType,},
                file: images,
                onSuccess: (data) => {
                    const ret = data.entity
                    rs(ret)
                    !!afterUpload && afterUpload({ret})
                },
                onError: (data) => {
                    rj(data)
                }
            })

        })
    }

    /**
     * 获取图片，不自动上传
     * @author  韦胜健
     * @date    2019/8/15 16:39
     */
    async getImage(multiple) {
        const images = await this.getFile({multiple})
        const ret = []
        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            ret.push({
                file: image,
                base64: await this.readAsDataURL(image),
            })
        }
        return ret
    }

    /**
     * 根据ids数组删除附件在数据库中的记录
     * @author  韦胜健
     * @date    2019/8/15 16:42
     */
    async deleteByIds(ids) {
        for (let i = 0; i < ids.length; i++) {
            await this._deleteById(ids[i])
        }
    }

    /**
     * 下载文件，得到blob对象（不存在跨域问题）
     * @author  韦胜健
     * @date    2019/12/16 17:20
     */
    getBlob(url) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('get', url, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response)
                } else {
                    reject(`下载失败，状态码为： ${xhr.status}`)
                }
            };
            xhr.onerror = (e) => {
                reject('下载失败!' + e)
            }
            xhr.ontimeout = () => {
                reject('下载超时!')
            }
            xhr.send();
        });
    }

    /**
     * 重命名下载文件
     * @author  韦胜健
     * @date    2019/12/16 17:18
     * @param   url                 文件地址
     * @param   name                文件名称
     */
    async download(url, name) {
        const blob = await this.getBlob(url)
        const saveAs = await LinkVue.resource.loadLib('saveAs')
        saveAs(blob, name)
    }

    /**
     * 删除附件
     * @author  韦胜健
     * @date    2019/8/15 16:42
     */
    async _deleteById(id) {
        return await this.$http.post(`action/${LinkVue.prefixUrl}/attachment/deleteById`, {id})
    }

}

export {FileService}
